<script lang="ts">
import { defineComponent, computed } from 'vue';
import { oneOfType } from 'vue-types';

import useConfig from '@/providers/config/useConfig';

export default defineComponent({
  name: 'HarmonLogo',
  props: {
    width: oneOfType([String, Number]).def('100%'),
    height: oneOfType([String, Number]).def('100%'),
  },
  setup() {
    const light = {
      text: '#4D4D4D',
      sqTop: '#000000',
      sqLeft: '#808080',
      sqRight: '#E6E6E6',
      sqBottom: '#CCCCCC',
    };
    const dark = {
      text: '#FFFFFF',
      sqTop: '#FFFFFF',
      sqLeft: '#E6E6E6',
      sqRight: '#808080',
      sqBottom: '#CCCCCC',
    };
    const config = useConfig();
    return {
      colors: computed(() => (config.config.name === 'light' ? light : dark)),
      config,
    };
  },
});
</script>
<!-- eslint-disable vue/max-len -->
<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 281 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- Squares -->
    <path :fill="colors.sqTop" opacity="0.2" d="M139.9,3.3l-36.1,36.1l36.1,36.1L176,39.4L139.9,3.3z" />
    <path :fill="colors.sqLeft" opacity="0.2" d="M103.9,39.3L67.9,75.4l36.1,36.1L140,75.4L103.9,39.3z" />
    <path :fill="colors.sqRight" opacity="0.2" d="M175.9,39.3l-36.1,36.1l36.1,36.1L212,75.4L175.9,39.3z" />
    <path :fill="colors.sqBottom" opacity="0.2" d="M139.9,75.3l-36.1,36.1l36.1,36.1l36.1-36.1L139.9,75.3z" />
    <!-- Lines -->
    <path d="M255.1,40.3L140.5,1L25,40.3" :stroke="colors.text" stroke-miterlimit="10" />
    <path d="M255.1,110l-114.6,39.4L25,110" :stroke="colors.text" stroke-miterlimit="10" />
    <!-- Harmon -->
    <path :fill="colors.text" d="M0,97V53.4h1.4v21.1h27.8V53.4h1.4V97h-1.4V75.9H1.4V97H0z" />
    <path :fill="colors.text" d="M47.5,97h-1.5l15.6-43.6h1.9L79.1,97h-1.4l-15-41.9h-0.2L47.5,97z" />
    <path :fill="colors.text" d="M94.7,97V53.4h12.8c2.3,0,4.5,0.5,6.5,1.6c1.9,1,3.4,2.5,4.4,4.3c1.1,2,1.7,4.3,1.6,6.5 c0.1,2.3-0.5,4.5-1.6,6.5c-1,1.8-2.6,3.3-4.4,4.3c-2,1.1-4.2,1.6-6.5,1.5H95.3v-1.4h12.1c2,0,4-0.4,5.8-1.4c1.6-0.9,3-2.2,3.9-3.8 c1-1.8,1.5-3.8,1.4-5.8c0-2-0.4-4.1-1.4-5.8c-0.9-1.6-2.3-3-3.9-3.9c-1.8-0.9-3.8-1.4-5.8-1.4H96V97H94.7z M111.3,77.1L122,97h-1.5 l-10.7-19.9H111.3z" />
    <path :fill="colors.text" d="M137.9,53.4h1.2l17.8,41.6h0.2l17.8-41.6h1.2V97h-1.4V57.6h-0.2L157.7,97h-1.4l-16.9-39.4h-0.2V97h-1.3V53.4z" />
    <path :fill="colors.text" d="M229.8,75.2c0.1,4-0.7,8-2.3,11.7c-1.4,3.2-3.5,5.9-6.3,7.9c-2.8,1.8-6.1,2.8-9.4,2.8c-3.4,0-6.6-1-9.5-2.8 c-2.8-2-5-4.7-6.3-7.9c-3-7.5-3-15.9,0-23.4c1.4-3.2,3.6-5.9,6.4-7.9c2.8-1.8,6.1-2.8,9.4-2.8c3.4,0,6.6,1,9.4,2.8 c2.8,2,5,4.7,6.4,7.9C229.1,67.2,229.9,71.2,229.8,75.2z M228.4,75.2c0.1-3.8-0.6-7.5-2.1-11c-1.2-3-3.3-5.5-5.9-7.4 c-2.6-1.7-5.6-2.6-8.7-2.6c-3.1,0-6.1,0.9-8.7,2.6c-2.6,1.9-4.6,4.4-5.9,7.4c-2.8,7.1-2.8,14.9,0,22c1.2,3,3.2,5.5,5.8,7.4 c2.6,1.7,5.6,2.7,8.8,2.7c3.1,0,6.2-0.9,8.8-2.7c2.6-1.9,4.6-4.4,5.9-7.4C227.8,82.7,228.5,78.9,228.4,75.2z" />
    <path :fill="colors.text" d="M280.1,53.4V97h-1.4l-29.8-41.1h-0.2V97h-1.4V53.4h1.4l29.8,41.1h0.2V53.4H280.1z" />
  </svg>
</template>
